import classnames from 'classnames'

import Textarea from '../Textarea'
import Button from '../Button'

import styles from './styles.module.scss'

export const RatingModalContent = ({
    ratingExplanation,
    ratingText,
    ratingArray,
    setRating,
    rating,
    onSubmit,
    onSubmitDisabled,
    questionText,
    questionHint,
    onSkip,
    setRatingFeedbackText,
    ratingFeedbackText,
    textFeedbackRequired,
    pending,
}) => (
    <>
        <p className="text-base">{ratingText}</p>
        <p className="text-small font-weight-bold">{ratingExplanation}</p>
        <ul className={styles.ratingList}>
            {ratingArray.map((item, index) => (
                <li
                    key={index}
                    className={classnames(
                        styles.ratingListItem,
                        rating === index && styles.ratingListItemActive,
                        rating !== null && rating !== index && styles.ratingListItemDisabled
                    )}
                    onClick={() => setRating(index)}>
                    {item}
                </li>
            ))}
        </ul>
        <p className="text-base mb-0">{questionText}</p>
        {textFeedbackRequired && (
            <Textarea
                label={questionHint}
                name="ratingFeedback"
                textareaClassName="textarea__rating"
                labelClassName="textarea__rating-label"
                onChange={setRatingFeedbackText}
                value={ratingFeedbackText}
            />
        )}
        <div className="d-flex">
            <Button type="button" btnStyle="outline" onClick={onSkip} className={styles.ratingModalBtn}>
                <T>home.page.nps.modal.skip</T>
            </Button>
            <Button
                type="submit"
                btnStyle="primary"
                onClick={() => onSubmit(rating, ratingFeedbackText)}
                disabled={onSubmitDisabled}
                isLoading={pending}
                className={styles.ratingModalBtn}>
                <T>home.page.nps.modal.submit</T>
            </Button>
        </div>
    </>
)
